import React from "react";
import { Link } from "react-router-dom";
import {
  Tag,
  Heading,
  Lead,
  BtnPrimary,
  BtnOutline,
  Card,
  IconBox,
  Section,
} from "../components/UI";
import StatsBar from "../components/StatsBar";
import styles from "./Home.module.css";

const SERVICES = [
  // {
  //   icon: "💻",
  //   title: "Software Development",
  //   desc: "Custom software, web apps, mobile apps, SaaS, and enterprise systems — end-to-end.",
  //   path: "/software",
  // },
  // {
  //   icon: "📱",
  //   title: "Application Development",
  //   desc: "High-performance web, mobile, and enterprise applications for all platforms.",
  //   path: "/app-dev",
  // },
  {
    icon: "🏢",
    title: "HR Solutions",
    desc: "Metawave Solutions providing specialized HR services to clients in India across different sectors.",
    // path: "/staffing",
  },
  {
    icon: "🤝",
    title: "Staffing Services",
    desc: "We have built a solid reputation in providing the highest quality support to clients and candidates.",
    // path: "/staffing",
  },
  {
    icon: "⚙️",
    title: "Outsourcing Services",
    desc: "We are a services company in the BPO industry providing back office services to our various clients.",
    // path: "/staffing",
  },
  // {
  //   icon: "🎓",
  //   title: "IT Training",
  //   desc: "Certified professionals teaching Java, Python, AI/ML, Salesforce, Power BI, and more.",
  //   path: "/training",
  // },
];

const WHY = [
  {
    t: "Experienced Development Team",
    d: "A skilled team delivering high-quality solutions with expertise and innovation.",
  },
  {
    t: "Scalable & Secure Solutions",
    d: "Built to grow with your business while ensuring top-level security and performance.",
  },
  {
    t: "Agile Development Approach",
    d: "Flexible and iterative processes to deliver faster and adapt to changing needs.",
  },
  {
    t: "On-Time Delivery",
    d: "Committed to meeting deadlines without compromising quality.",
  },
  {
    t: "Cost-Effective Services",
    d: "High-value solutions designed to maximize ROI and minimize costs.",
  },
  {
    t: "24/7 Support",
    d: "Round-the-clock assistance to ensure smooth and uninterrupted operations.",
  },
];

export default function Home() {
  return (
    <>
      {/* ── Hero ─────────────────────────────────────────────── */}
      <div className={styles.hero}>
        <div className={styles.heroBg} />
        <div className={styles.heroGrid} />
        <div className={styles.heroInner}>
          {/* <div className={`${styles.heroBadge} animate-fade-up delay-1`}>
            Software · HR · Staffing · IT Training
          </div> */}
          <h1 className={`${styles.heroTitle} animate-fade-up delay-2`}>
            Empowering Business Through{" "}
            <em className={styles.heroEm}>People &amp; Technology</em>
          </h1>
          <p className={`${styles.heroSub} animate-fade-up delay-3`}>
            Metawave Solutions delivers expert software development, HR
            services, flexible staffing, and cutting-edge IT training — helping
            organizations grow and professionals thrive.
          </p>
          <div className={`${styles.heroBtns} animate-fade-up delay-4`}>
            <BtnPrimary to="/services">Explore Services</BtnPrimary>
            <BtnOutline to="/contact-us">Get in Touch</BtnOutline>
          </div>
        </div>
      </div>

      {/* ── Stats ─────────────────────────────────────────────── */}
      <StatsBar />

      {/* ── About Snippet ─────────────────────────────────────── */}
      <Section variant="paper">
        <div className={styles.aboutGrid}>
          <div>
            <Tag>About Us</Tag>
            <Heading>A Trusted Partner for Business &amp; Technology</Heading>
            <Lead>
              Metawave Solutions is a team of talented professionals
              specializing in Software Development, Application Development, HR
              Services, Staffing, and Outsourcing Services. Supported by an
              experienced pool of experts, we have built strong capabilities in
              delivering cost-effective, high-quality, consistent, and reliable
              business solutions to corporate clients across the globe. We
              provide dependable software development and HR services, along
              with advanced business solutions, catering to a wide range of
              organizations—from dynamic small and medium enterprises to Fortune
              100+ companies.
            </Lead>
            <div className={styles.aboutBtns}>
              <BtnPrimary to="/about-us">Learn More</BtnPrimary>
              {/* <BtnOutline to="/contact-us">Contact Us</BtnOutline> */}
            </div>
          </div>
          <div className={styles.aboutVisual}>
            <div className={styles.aboutVisualBg} />
            <div className={styles.avPill}>Full-Range IT Recruitment</div>
            <h3 className={styles.avTitle}>
              From Concept to Deployment — We've Got You Covered
            </h3>
            <ul className={styles.avList}>
              {[
                "HR Solutions across multiple sectors in India",
                "Staffing with consulting & right-to-hire positions",
                "BPO / Outsourcing for back-office services",
                "IT Training with certified professionals",
                "Direct Placements in the US and India",
              ].map((item, i) => (
                <li key={i}>
                  <span className={styles.avArrow}>→</span>
                  {item}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </Section>

      {/* ── Services ──────────────────────────────────────────── */}
      <Section variant="dark">
        <Tag light>What We Offer</Tag>
        <Heading light>Our Core Services</Heading>
        <Lead light>End-to-End HR, Staffing & Outsourcing Solutions</Lead>
        <div className={styles.servicesGrid}>
          {SERVICES.map((svc, i) => (
            <Link key={i} to={svc.path} className={styles.svcCard}>
              <div className={styles.svcIcon}>{svc.icon}</div>
              <h3 className={styles.svcTitle}>{svc.title}</h3>
              <p className={styles.svcDesc}>{svc.desc}</p>
              {/* <Link to="/services" className={styles.svcArrow}>
                Learn more →
              </Link> */}
            </Link>
          ))}
        </div>
      </Section>
      {/* ── Industries Teaser ─────────────────────────────────── */}
      <Section variant="paper" className={styles.sectionCenter}>
        <Tag>Industries We Serve</Tag>
        <Heading>Built for Your Sector</Heading>
        <div className={styles.indRow}>
          {[
            "🏥 Healthcare",
            "🛒 E-commerce",
            "🎓 Education",
            "💰 Finance",
            "🚚 Logistics",
            "🏠 Real Estate",
          ].map((ind, i) => (
            <Link key={i} to="/industries" className={styles.indChip}>
              {ind}
            </Link>
          ))}
        </div>
      </Section>

      {/* ── Why Us ────────────────────────────────────────────── */}
      <Section variant="dark">
        <Tag light>Why Choose Us</Tag>
        <Heading light>What Sets Metawave Apart</Heading>
        <div className={styles.whyGrid}>
          {WHY.map((w, i) => (
            <div key={i} className={styles.whyItem}>
              <div className={styles.whyCheck}>✓</div>
              <div>
                <h4 className={styles.whyTitle}>{w.t}</h4>
                <p className={styles.whyDesc}>{w.d}</p>
              </div>
            </div>
          ))}
        </div>
      </Section>

      {/* ── CTA Banner ────────────────────────────────────────── */}
      <div className={styles.ctaBanner}>
        <h2 className={styles.ctaTitle}>Ready to Work Together?</h2>
        <p className={styles.ctaSub}>
          Get in touch and our team will respond promptly.
        </p>
        <BtnPrimary to="/contact-us">Contact Us →</BtnPrimary>
      </div>
    </>
  );
}
